// Projects data.
// Note: Here we are getting data from a js file, but in a different project I'll be fetching these projects from some srt of APIs.

const projects = [
	{
		id: 1,
		title: 'Site web Yams logistique',
		category: ' Site Web ',
		img: require('@/assets/images/siteYams.png'),
	},
	{
		id: 2,
		title: 'Yams Client',
		category: ' Application Mobile',
		img: require('@/assets/images/client.png'),
	},
	{
		id: 3,
		title: 'Yams Transporteur',
		category: 'Application Mobile',
		img: require('@/assets/images/transporteur.png'),
	},
	{
		id: 4,
		title: 'easyPay',
		category: 'UI/UX Design',
		img: require('@/assets/images/easyPay.png'),
	},
	{
		id: 5,
		title: 'TransAkanda',
		category: ' Application Web',
		img: require('@/assets/images/TranspAK.png'),
	},
	{
		id: 6,
		title: 'Akanda AVenir',
		category: 'Application Web ',
		img: require('@/assets/images/akandaT.png'),
	},
];

export default projects;
